import React from 'react'
import { Tabs } from 'antd'
import { BannerList } from '../Banners/BannerList'
import { CollectionList } from '../Collections/CollectionList'
import { FeedSettings } from '../FeedSettings/FeedSettings'
import { ScrollBannerList } from '../ScrollBanners/ScrollBannerList'
import { SelectedSellers } from '../SelectedSellers/SelectedSellers'
import { VacancyList } from '../Vacancies/VacancyList'

export const Main: React.FC = () => (
  <div style={{ paddingBottom: 80 }}>
    <Tabs
      defaultActiveKey='banners'
      items={[
        {
          key: 'banners',
          label: 'Баннеры',
          children: <BannerList />
        },
        {
          key: 'scroll-banners',
          label: 'Скролл-баннеры',
          children: <ScrollBannerList />
        },
        {
          key: 'collections',
          label: 'Подборки',
          children: <CollectionList />
        },
        {
          key: 'feed',
          label: 'Выдача',
          children: <FeedSettings />
        },
        {
          key: 'selected-sellers',
          label: 'Избранные продавцы',
          children: <SelectedSellers />
        },
        {
          key: 'vacancies',
          label: 'Вакансии',
          children: <VacancyList />
        }
      ]}
    />
  </div>
)
